import { Tooltip } from "@material-ui/core";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import $ from "jquery";
import { DEFAULT_GREY_HEX_CODE } from "../../constants";

export const TemplateStarRating = ({ ...props }) => {
  const [checked, setChecked] = React.useState({});
  let styleBase = getStyle(props.display[0]);
  let showLabel = props.display[0]?.match(/showlabel\((.*?)\)/g);

  showLabel = showLabel != null ? showLabel[0] : showLabel;
  let positions = evalPositionLabelStar(showLabel);

  return (
    <>
      <div className="star_rating row">
        {props.choicesListNew[props.choice]?.map((choice, index) => {
          return (
            <Tooltip
              key={`${props.choice}_${choice.name}_key`}
              title={
                (props.previewForm || props.collector.Choice === "TRUE") &&
                window.ListNameDefault.indexOf(props.choice) === -1
                  ? "Double click to edit"
                  : ""
              }
              placement="bottom"
            >
              <div style={{ position: "relative" }}>
                <label
                  className="btn"
                  style={{
                    wordBreak: "break-word",
                    padding: "0px 5px",
                    width: "calc(20px + " + styleBase.fontSize+")",
                    textAlign: "center",
                  }}
                >
                  <div
                    // className="select_one_q1_b3-hover-4"
                    style={
                      index <= Object.keys(checked)[0] &&
                      Object.values(checked)[0]
                        ? styleBase.checked
                        : styleBase.unchecked
                    }
                    onClick={(e) => {
                      if (checked?.[index]) {
                        setChecked({ [index]: false });
                      } else {
                        setChecked({ [index]: true });
                      }
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDoubleClick={(e) => {
                      !props.previewForm && (props.previewForm ||
                        props.collector.XlsType !== "SINGLE_TEMPLATE") &&
                        window.ListNameDefault.indexOf(props.choice) === -1 &&
                        props.handleClickOpen(choice);

                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onMouseOver={() => {
                      $(`#${props.choice}_${choice.name}_dlt_btn`).css(
                        "opacity",
                        "1"
                      );
                    }}
                    onMouseOut={() => {
                      $(`#${props.choice}_${choice.name}_dlt_btn`).css(
                        "opacity",
                        "0"
                      );
                    }}
                  >
                    <i
                      className="fas fa-star"
                      aria-hidden="true"
                      style={{ fontSize: styleBase.fontSize }}
                    />
                  </div>
                  <span
                    className={
                      positions?.indexOf(choice.name) > -1 ? "" : "d-none"
                    }
                    style={{
                        fontSize:"var(--font-size)",
                        color:"var(--answer-color)"
                    }}
                  >
                    {choice["label::" + props.language]}
                  </span>
                </label>
                {!props.previewForm && (props.previewForm || props.collector.Choice === "TRUE") &&
                  window.ListNameDefault.indexOf(props.choice) === -1 && (
                    <lable
                      id={`${props.choice}_${choice.name}_dlt_btn`}
                      className="m-0 dlt_choice_btn"
                      onClick={(e) => {
                        props.handleDeleteChoice(choice, props.choicesList);
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      style={{ top: "0", right: "0" }}
                    >
                      <CloseIcon fontSize="small" />
                    </lable>
                  )}
              </div>
            </Tooltip>
          );
        })}
      </div>
    </>
  );
};

const getStyle = (appearances) => {
  let colorCode = appearances.match(/(?:[#0-9a-f]{7})|(?:[0-9a-f]{6})/gi);
  let fontSize = appearances.match(/[0-9]{2}pt/gi);
  console.log(appearances,fontSize)
  let unchecked = {};
  let checked = {};
  const itemStyle = {
    cursor: "pointer",
  };

  const regex = RegExp("#[0-9a-fA-F]{6}");
  if (colorCode === null) {
    unchecked["color"] = "#" + DEFAULT_GREY_HEX_CODE;
    checked["color"] = "#FFCB00";
  } else {
    if (regex.test(colorCode)) {
      unchecked["color"] = "#" + DEFAULT_GREY_HEX_CODE;
      checked["color"] = colorCode;
    } else {
      if (colorCode.length === 2) {
        unchecked["color"] = "#" + colorCode[0];
        checked["color"] = "#" + colorCode[1];
      } else {
        unchecked["color"] = "#" + DEFAULT_GREY_HEX_CODE;
        checked["color"] = "#" + colorCode;
      }
    }
  }

  if (fontSize === null) {
    itemStyle["fontSize"] = "calc(var(--font-size) * 2)";    
  } else {
    itemStyle["fontSize"] = fontSize[0];
}

  itemStyle.unchecked = {
    ...itemStyle,
    ...unchecked,
  };

  itemStyle.checked = {
    ...itemStyle,
    ...checked,
  };
  return itemStyle;
};

const evalPositionLabelStar = (func) => {
  try {
    return eval(func);
  } catch (e) {
    console.error("Got error when eval, " + func + ", " + e);
  }
};

const showlabel = (...options) => {
    options = options.map((option)=> option.toString())
  return options;
};
